import { createAction } from 'redux-actions';

// eslint-disable-next-line i18next/no-literal-string
const FIRST_STEP = 'request';
// eslint-disable-next-line i18next/no-literal-string
const SECOND_STEP = 'receive';

export const twoStepAction = (
  type,
  firstStep = FIRST_STEP,
  secondStep = SECOND_STEP,
) => ({
  [firstStep]: createAction(`${type}_${firstStep}`),
  [secondStep]: createAction(`${type}_${secondStep}`),
});
